import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAxios } from "../../utils/useAxios";
import { useAuth } from "@/utils/useAuth";

/**
 * Mesma estrutura de `SendEmailFinishAccount.tsx`, mas com corpo específico
 * para o fluxo de cancelamento de clínica (`CancelClinicDialog.tsx`), avisando
 * o time Fluxmed sobre a solicitação e trazendo a referência da organização.
 */
export async function SendEmailCancelClinic(
  sender: any,
  organizationName: any,
  identifier?: any
) {
  const url = `${endpoints.Gmail}`;

  const data = {
    recipientEmail: "contato@fluxmed.com.br",
    subject: "Solicitação de Encerramento de Clínica Fluxmed",
    body: `<html>
    <head> Identificador: ${identifier} </head>
    
    <body>
    
    </strong> O usuário ${sender?.name} solicitou o encerramento da clínica ${organizationName} na plataforma Fluxmed! </strong>

    <a href=${endpoints.XDSB_domain}/portal> Acessar Fluxmed  </a>
    
    </body>
    
    </html>`,
  };

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 8000 })
    .then((response) => {
      // O endpoint do Gmail responde 200 (Success), não 201 (Created).
      // Checar só por "Created" fazia cair no catch mesmo com o POST certo.
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`SendEmail : ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("SendEmail ", error);
      toast.error(`SendEmail Erro: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
